











































import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ArenaSignTemplateAfterSignSettingModel, MStoreConstants } from '@/types';
import { MTablehelper, RouteHelpers } from '@/mixins';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { RouteRegEx } from '@/types/enums';
import Vue from 'vue';
import { BvTableFieldArray } from 'bootstrap-vue';

export default Vue.extend({
  name: 'ArenaSignAfterSignMappingsManagement',
  mixins: [MTablehelper, RouteHelpers],
  props: {
    fields: {
      type: Array as () => BvTableFieldArray,
      required: true
    },
    data: {
      type: Array as () => ArenaSignTemplateAfterSignSettingModel[],
      required: true
    }
  },
  data() {
    return {
      documentTypeFilter: 0
    };
  },
  computed: {
    items(this: any) {
      return this.data.map((x: ArenaSignTemplateAfterSignSettingModel) => {
        return {
          ...x,
          targetCabinetDescription: x.targetCabinet?.description,
          targetDocumentTypeDescription: x.targetDocumentType?.description,
          sourceDocumentTypeDescription: x.sourceDocumentType.description
        };
      });
    }
  },
  methods: {
    navigateToId(this: any, id: number) {
      this.$emit('on-edit-clicked', id);
    }
  },
  created(this: any) {
    this.APP_NAME = MStoreConstants.AppName;
  },
  components: {
    MStoreTable,
    LoadingSpinner,
    MStoreFormSelect
  }
});
